import * as React from 'react';
import { useParams } from 'react-router-dom';
import {
  getEntityIcon,
  getEntityType,
  getPluralEntity,
} from '../utils/entities';
import { capitalize } from '@mui/material';
import { useRouteConfig } from '../utils/useRouteConfig';
import { theme } from '../utils/theme';

export const PageTitle = ({
  text,
  children,
  sx,
  textSx,
}: {
  text?: string;
  children?: any;
  sx?: any;
  textSx?: any;
}) => {
  const urlParams = useParams();
  const { pluralEntityType } = urlParams;
  const entityType = getEntityType(pluralEntityType);
  const pluralEntity = getPluralEntity(entityType)() as string;

  const routeConfig = useRouteConfig();
  const IconComponent = getEntityIcon(
    pluralEntity || routeConfig?.entityTypes?.[0],
  );

  return (
    <div
      data-cy="page-title"
      style={{
        marginLeft: theme.spacing(1),
        marginBottom: theme.spacing(3),
        ...(sx || {}),
      }}
    >
      <span>
        {IconComponent &&
          React.createElement(IconComponent, {
            style: {
              height: '2.5em',
              width: '2.5em',
              verticalAlign: 'bottom',
              marginRight: theme.spacing(2),
            },
          })}
        <span
          style={{
            fontFamily: 'Source Serif Pro,serif',
            fontSize: '2em',
            background:
              'no-repeat bottom left url(assets/images/hero_brush_stroke.svg)',
            backgroundSize: 'contain',
            ...textSx,
          }}
        >
          {text || capitalize(pluralEntity || routeConfig?.title || '')}
        </span>
      </span>
      {children}
    </div>
  );
};
